class PermissionUtil {


    static PERMISSION_LOJA_ONGRID = "lojas_loja_ongrid"
    static PERMISSION_LOJA_OFFGRID = "lojas_loja_offgrid"
    static PERMISSION_LOJA_AVULSO = "lojas_loja_avulso"
    static PERMISSION_LOJA_EXPORTAR_PLANILHA = "lojas_exportar_planilha"
    static PERMISSION_LOJA_VISUALIZAR_CODIGO_COMPONENTE = "componentes_visualizar_codigo"
    
    static can(permission: string, permissionList: string[]): boolean {

        if (permissionList.length) {

            // Caso seja administrador
            if (permissionList[0] === "*") {
                return true;
            }
    
            return permissionList.includes(permission);
        } 

        return false;
    }

    static isAdministrador(permissionList: string[]): boolean {
        if (permissionList.length) {

            // Caso seja administrador
            if (permissionList[0] === "*") {
                return true;
            }
        } 

        return false;
    }

}


export { PermissionUtil }